var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-text"},[(_vm.label)?_c('div',{staticClass:"input-text-label main-text-color"},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.label))+"\n    ")]):_vm._e(),_c('el-input',{attrs:{"value":_vm.inputValue,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.onChange,"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }